import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { ipTypesOptions } from "../data/ipTypesOptions";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BlockIcon from "@mui/icons-material/Block";
import i18n from "../../../locales/i18n";

const deleteIp = ({
  index,
  packUpdateBatch,
}: {
  index: number;
  packUpdateBatch: stdObject;
}) => {
  const { windowValues, setWindowValues } = packUpdateBatch;
  let tempWindow = { ...windowValues };
  tempWindow.ip.splice(index, 1);
  setWindowValues({ ...windowValues });
};

const addIp = ({ packUpdateBatch }: { packUpdateBatch: stdObject }) => {
  const { windowValues, setWindowValues } = packUpdateBatch;
  let tempWindow = { ...windowValues };
  tempWindow.ip.unshift({
    BLOIP: 0,
    CODIP: "",
    LOCIP: 0,
  });
  setWindowValues({ ...windowValues });
};

const changeAccessLogValue = ({
  index,
  key,
  value = "",
  packUpdateBatch,
}: {
  index: number;
  key: string;
  value?: any;
  packUpdateBatch: stdObject;
}) => {
  const { windowValues, setWindowValues } = packUpdateBatch;
  let tempWindow = { ...windowValues };
  tempWindow.ip[index][key] = value;
  if (key === "LOCIP") {
    tempWindow.ip[index].CODIP = "";
  }
  setWindowValues({ ...windowValues });
};

export const createIpTable = ({
  t,
  windowValues,
  setWindowValues,
}: stdObject) => {
  const packUpdateBatch = {
    windowValues,
    setWindowValues,
  };

  const language = i18n.language;
  const countriesList = (
    i18n.store.data[language].translation as Record<string, any>
  ).country;

  return "ip" in windowValues
    ? [
        {
          data: [
            " ",
            {
              type: "button",
              label: t("p.new"),
              onClick: () =>
                addIp({
                  packUpdateBatch,
                }),
            },
          ],
        },
        ...windowValues.ip.map((e: stdObject, index: number) => {
          return {
            data: [
              {
                type: "icon",
                Icon: BlockIcon,
                color: e.BLOIP ? colors.red : colors.grey,
                onClick: () =>
                  changeAccessLogValue({
                    index,
                    key: "BLOIP",
                    value: e.BLOIP ? 0 : 1,
                    packUpdateBatch,
                  }),
              },
              {
                type: e.LOCIP === 4 ? "select" : "text",
                value: e.CODIP,
                options:
                  e.LOCIP === 4
                    ? [
                        { label: "", value: "" },
                        ...Object.entries(countriesList).map((e) => {
                          return { label: e[1], value: e[0] };
                        }),
                      ]
                    : [],
                // style: { width: 110 },
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  changeAccessLogValue({
                    index,
                    key: "CODIP",
                    value: v.target.value,
                    packUpdateBatch,
                  }),
              },
              {
                type: "select",
                value: e.LOCIP,
                options: ipTypesOptions.map((v: stdObject) => {
                  return { ...v, label: t(v.label) };
                }),
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  changeAccessLogValue({
                    index,
                    key: "LOCIP",
                    value: Number(v.target.value),
                    packUpdateBatch,
                  }),
              },
              {
                type: "icon",
                Icon: DeleteForeverIcon,
                color: colors.red,
                onClick: () =>
                  deleteIp({
                    index,
                    packUpdateBatch,
                  }),
              },
            ],
          };
        }),
      ]
    : [];
};
